import * as React from "react"

import { cn } from "../../lib/utils"
import { FOCUS_RING } from "../../lib/focus-ring"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[56px] w-full rounded-md border border-input bg-transparent px-3 py-1.5 text-base shadow-sm placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 md:min-h-[64px] md:px-2.5 md:py-1 md:text-ds-body",
        FOCUS_RING,
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
